<template>
    <div id="userBuyCard">
        <em><span>尊敬的客户，您的买卡申请预计24小时内处理完毕，请耐心等待。</span></em>



        <van-cell-group class="form-input">
            <van-field
                v-model="recordLoginText"
                required
                label="号码：" 
                readonly
            />

            <van-field
                v-model="userInfo.takeNickname"
                required
                clearable
                label="收件人姓名："
                placeholder="请输入您的姓名"
            />

            <van-field
                v-model="userInfo.takePhone"
                required
                clearable
                name="phoneValidator"
                label="手机号码："
                placeholder="请输入您的手机号码" 
            />

            <van-field
                v-model="userInfo.pcaAddress"
                required
                clearable
                label="地区："
                placeholder="请选择地区"
                readonly
                @click="showAddressVisible()"
            />

            <van-field
                v-model="userInfo.takeAddress"
                required
                clearable
                label="详细地址："
                placeholder="请输入您的详细地址"
            />

            <van-field
                v-model="userInfo.changeCmccSimName"
                required
                clearable
                label="卡类型："
                placeholder="请选择卡类型"
                readonly
                @click="showPopupVisible()"
            />
            <p class="tip">{{tips}}</p>

            <van-field name="stepper" label="数量" required>
              <template #input>
                <van-stepper v-model="userInfo.iccidSize" @change="onChange"/>
              </template>
            </van-field>

            <van-field
                v-model="userInfo.price"
                required
                label="价格："
                readonly
            />

        </van-cell-group>



        <!--  地区选择  -->
        <van-popup v-model="addressVisible"  position="bottom">
            <van-area
              :area-list="areaList"
              :columns-placeholder="['请选择', '请选择', '请选择']"
              @cancel="cancelSelectAddress()"
              @confirm="selectAddress"
            />
        </van-popup>

        <!-- 卡类型选择 -->
        <van-popup v-model="popupVisible" position="bottom">
            <van-picker
              show-toolbar
              :columns="slots"
              :default-index="defaultIndex"
              @cancel="popupVisible = !popupVisible"
              @confirm="selectValue"
            />
        </van-popup>


        <div class="btnOuter">
            <mt-button type="primary" size="large" @click="payCost()">支付费用</mt-button>
        </div>
    </div>
</template>
<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';

import { wxRequest} from '@/api/user.js' 
import myaddress from '@/utils/pca.json'
import areaListData from '@/utils/Area.js'

export default {
    name: 'userBuyCard',
    data(){
        return {
             app:localStorage.getItem('app'),
            userInfo: {
                oldIccid: this.$store.state.iccid,
                takeNickname: '',
                takePhone: '',
                pcaAddress: '',
                takeAddress: '',
                disposeState: '',
                disposeRemark: '',
                changeCmccSim: null,
                changeCmccSimName: '',
                equipment:'',
                perprice: '',
                price: '',
                iccidSize: 1
            },
            slots: ['移动卡', '电信卡', '联通卡', '任意卡'],
            defaultIndex: 1,
            popupVisible: false, //选择卡窗口

            addressVisible: false,  //选择地址窗口
            areaList: areaListData,  //选择地址列表
            addressTmp: '',

            tips:'温馨提醒：电信卡充足，其他卡暂时缺货。',
            recordLoginText: localStorage.getItem('recordLoginText')
        }
    },
    methods: {
        payCost(){
            if(this.userInfo.takeNickname == '' || this.userInfo.takePhone == '' || this.userInfo.takeAddress == '' || this.userInfo.pcaAddress == '' || this.userInfo.changeCmccSimName == ''){
                Dialog.alert({title: '提示', message:'请确保信息完整正确'});
                return;
            }
            if(this.userInfo.takePhone && !(/^[1][3,4,5,7,8][0-9]{9}$/.test(this.userInfo.takePhone))){
                Dialog.alert({title: '提示', message:'请填写正确的手机号'});
                return;
            }
            let data = JSON.parse(JSON.stringify(this.userInfo)); 
            const formData = new FormData();
             formData.append('app',this.app);
            Object.keys(data).forEach((key) => {
              formData.append(key, data[key]);
            });
            wxRequest("order/buy/sim", formData, "post").then(res => {         
                if(res.data.code == 200){
                      if(this.app){
                         location.href=res.data.data.mweb_url;
                   }else{
                        let _this = this;
                    let param = res.data.data.param;        
                    WeixinJSBridge.invoke(
                        'getBrandWCPayRequest', param,
                        function(res){
                          if(res.err_msg == "get_brand_wcpay_request:ok" ){
                              _this.$router.push({
                                path: '/user/home'
                              })
                          } 
                        }
                    )
                   }
                }else{
                  Dialog.alert({title: '提示', message:res.data.message});
                }
            })
        },

        /**选择卡类型 */
        showPopupVisible(){
            this.popupVisible = true;
        },

        selectValue(value, index){
            this.userInfo.changeCmccSimName = value
            this.userInfo.changeCmccSim = value == '电信卡' ? 1 : value == '移动卡' ? 2 : value == '联通卡' ? 3 : 4;
            this.popupVisible = false;
        },
        /**选择卡类型结束 */

        /**选择地址 */
        showAddressVisible(){
            this.addressVisible = true;
        },

        cancelSelectAddress(){
            this.addressTmp = '';
            this.userInfo.pcaAddress = '';
            this.addressVisible = false;
        },
   
        selectAddress(values){
            if(!values[0].code || values[0].code.length<1){
                Toast.fail('请选择地区');
                return ;
            }

            if(!values[1].code || values[1].code.length<1){
                Toast.fail('请选择地区');
                return ;
            }

            if(!values[2].code || values[2].code.length<1){
                Toast.fail('请选择地区');
                return ;
            }

            if(values[0].code == '110000' || values[0].code == '120000' || 
                values[0].code == '310000' || values[0].code == '500000'){
                this.addressTmp = values[0].name + values[2].name
            }else{
                this.addressTmp = values[0].name + values[1].name + values[2].name
            }   

            this.userInfo.pcaAddress = this.addressTmp;
            this.addressVisible = false;
        },
        /**选择地址结束 */

        //获取价格
        getPrice(){
          let data = {
            oldIccid: this.userInfo.oldIccid
          }
          wxRequest('applyChangeSim/buy/iccid/price', data, 'post').then(res => {
            if(res.data.code == 200){
              this.userInfo.perprice = res.data.data/100;
              this.userInfo.price = this.userInfo.iccidSize * this.userInfo.perprice
            }
          })
        },
        //步进器改变执行
        onChange(val){
          this.userInfo.iccidSize = val;
          this.userInfo.price = this.userInfo.iccidSize * this.userInfo.perprice
        }
    },
    created(){
        this.getPrice();
    }
}
</script>
<style lang="less" scoped>
#userBuyCard {
    em {
        display: block;
        background: #26a2ff;
        color: #fff;
        padding: 10px;
        line-height: 1.5em;
    }

    .btnOuter {
        margin: 20px 0 40px;
        padding: 0 5%;
    }


    .form-input{
        .tip{
            padding: 2px 10px;
        }
    }

    .tip{
        color: red;
        line-height: 16px;
        font-size: 12px;
    }
}
</style>

<style>
#userBuyCard .form-input .van-field__control{
    line-height: 24px;
}
</style>